import { apiPost } from './client'

export interface BriefResponse {
  headline?: string
  regime?: string
  near_trigger_plans?: Array<Record<string, unknown>>
  open_positions?: Array<Record<string, unknown>>
  concerns?: string[]
  recommended_actions?: string[]
  per_position?: Array<Record<string, unknown>>
  recent_outcomes?: Array<Record<string, unknown>>
  generated_at?: string
  error?: string
  [k: string]: unknown
}

export const generateMorningBrief = () => apiPost<BriefResponse>('/briefs/morning', {})
export const generateRollWeekBrief = () => apiPost<BriefResponse>('/briefs/roll_week', {})
